import React, { Suspense, useEffect } from "react";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import FreeAuthRoute from "./routes/FreeAuthRoute";
import PageNotFound from "./pages/PageNotFound";
import { routerData } from "./config/RoutesConfig";
import FrontLayout from "./layouts/front/FrontLayout";
import AdminLayout from "./layouts/auth/AdminLayout";
import UserRoute from "./routes/UserRoute";
import AdminRoute from "./routes/AdminRoute";
import BlankLayout from "./layouts/BlankLayout";
import AuthRoute from "./routes/AuthRoute";
import LoadingFallback from "./components/elements/LoadingFallback";
import AdminNotAllowRoute from "./routes/AdminNotAllowRoute";
import { useSelector } from "react-redux";
import AuthLayout from "./layouts/AuthLayout";

import FrontUserLayout from "./layouts/front/FrontUserLayout";
import FrontInnerPanelLayout from "./layouts/front/FrontInnerPanelLayout";
import FrontPromoterLayout from "./layouts/front/FrontPromoterLayout";
import OrganizationRoute from "./routes/OrganizationRoute";

const CreateRoutes = () => {
  const { session } = useSelector((state) => state?.authProvider);
  const { selectedOrganizationDetails } = useSelector(
    (state) => state?.organization
  );
  return (
    <Suspense fallback={<LoadingFallback />}>
      <ScrollToTop>
        <Routes>
          {(
            routerData({
              user: session?.user || {},
              selectedOrganization: selectedOrganizationDetails?.data || {},
            }) || []
          )
            ?.filter((item) => !item?.disabled || item?.disabled === undefined)
            ?.map((route, i) => {
              let Layout = React.Fragment;

              if (route.layout === "front") {
                Layout = FrontLayout;
              } else if (route.layout === "admin") {
                Layout = AdminLayout;
              } else if (route.layout === "user") {
                Layout = FrontUserLayout;
              } else if (route.layout === "auth") {
                Layout = AuthLayout;
              } else if (route.layout === "frontUserInner") {
                Layout = FrontInnerPanelLayout;
              } else if (route.layout === "promoter") {
                Layout = FrontPromoterLayout;
              } else if (!route.layout) {
                Layout = BlankLayout;
              }

              return (
                <Route
                  key={route?.key || i}
                  path={route.path}
                  element={
                    route?.routeType === "user" ? (
                      <UserRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </UserRoute>
                    ) : route?.routeType === "organization" ? (
                      <OrganizationRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </OrganizationRoute>
                    ) : route?.routeType === "admin" ? (
                      <AdminRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AdminRoute>
                    ) : route?.routeType === "auth" ? (
                      <AuthRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AuthRoute>
                    ) : route?.routeType === "adminNotAllow" ? (
                      <AdminNotAllowRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AdminNotAllowRoute>
                    ) : (
                      <FreeAuthRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </FreeAuthRoute>
                    )
                  }
                >
                  <Route
                    path={route?.path}
                    exact
                    element={<route.component />}
                  />
                  {route?.subRoute?.map((sub, j) => (
                    <Route
                      key={j?.toString()}
                      path={sub?.path}
                      exact
                      element={<sub.component />}
                    />
                  ))}
                </Route>
              );
            })}
          {/* 404 Page */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </ScrollToTop>
    </Suspense>
  );
};

export default CreateRoutes;
